import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { CountryCode } from '../urls-config';
import { useTrimContext } from './hooks/useTrimContext';
import NavFooter from './PnfFooter';
import NavHeader from './NavHeader';
import PNFDisputeLandingPage from './dispute/PNFDisputeLandingPage';
import PNFDisputeSignInPage from './dispute/PNFDisputeSignInPage';
import PnfLandingPage from './PnfLandingPage';
import PnfSignInPage from './PnfSignInPage';

export function App() {
  const { context } = useTrimContext();
  return (
    <>
      {context && (
        <NavHeader
          authenticationState={context.authenticationState}
          currentLocale={context.currentLocale}
          isDisputeEnabled={context.isDisputeEnabled}
          isRetractEnabled={context.isRetractEnabled}
          supportedLanguages={context.supportedLanguages}
        />
      )}
      <BrowserRouter>
        <Switch>
          <Route
            exact
            path="/report/dispute"
            render={(props) => (
              <PNFDisputeLandingPage
                authenticationState={context?.authenticationState}
                routerProps={props}
                userFirstName={context?.firstName || ''}
              />
            )}
          />
          <Route
            exact
            path="/report/dispute/signin"
            render={() => (
              <>
                <div className="page-container">
                  <PNFDisputeSignInPage
                    authenticationState={context?.authenticationState}
                  />
                </div>
              </>
            )}
          />
          <Route
            exact
            path="/report/infringement/retract"
            render={(props) => (
              <PnfLandingPage
                authenticationState={context?.authenticationState}
                domainCountryCode={context?.domainCountryCode || CountryCode.US}
                routerProps={props}
                userFirstName={context?.firstName || ''}
              />
            )}
          />
          <Route
            exact
            path="/report/infringement/retract/signin"
            render={() => (
              <>
                <div className="page-container">
                  <PnfSignInPage
                    authenticationState={context?.authenticationState}
                    domainCountryCode={context?.domainCountryCode || CountryCode.US}
                  />
                </div>
              </>
            )}
          />
          <Route
            exact
            path="/report/infringement"
            render={(props) => (
              <>
                <div className="page-container">
                  <PnfLandingPage
                    authenticationState={context?.authenticationState}
                    domainCountryCode={context?.domainCountryCode || CountryCode.US}
                    routerProps={props}
                    userFirstName={context?.firstName || ''}
                  />
                </div>
              </>
            )}
          />
          <Route
            exact
            path="/report/infringement/signin"
            render={() => (
              <>
                <div className="page-container">
                  <PnfSignInPage
                    authenticationState={context?.authenticationState}
                    domainCountryCode={context?.domainCountryCode || CountryCode.US}
                  />
                </div>
              </>
            )}
          />
        </Switch>
      </BrowserRouter>
      {context && <NavFooter footerLinks={context.footerLinks} />}
    </>
  );
}
